import { GET_CLIENT_DETAIL } from '../actionTypes';

export const getClientDetail = (id, dispatch) =>{
  dispatch({
      type: GET_CLIENT_DETAIL,
      payload: id,
  })
}
